import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import PropTypes from "prop-types";

export default function SnackbarAlert(props) {
	const { onClose, message, open, severity } = props;
	return (
		<Snackbar open={open} autoHideDuration={4000} onClose={onClose}>
			<Alert onClose={onClose} severity={severity}>
				{message}
			</Alert>
		</Snackbar>
	);
}

SnackbarAlert.propTypes = {
	onClose: PropTypes.func.isRequired,
	message: PropTypes.string.isRequired,
	open: PropTypes.bool.isRequired,
	severity: PropTypes.string.isRequired,
};
